import { PartnerState } from 'types';
import { createReducer } from 'utils';

import { partnerHandlers } from './handlers';

export const partnerInitialState: Readonly<PartnerState> = {
  qualificationsList: [],
  rewardsList: [],
  statsList: {
    license_sales: 0,
    referrals_license_sales: 0,
    personal_sales_profit: 0,
    referrals_sales_profit: 0,
    // auto_bonus_profit: 0,
    pools_profit: 0,
  },
  referralsList: undefined,
  autoBonusList: [],
  autoTimeNextUpdate: undefined,
};

export default createReducer(partnerInitialState, partnerHandlers);
